import {createSelector} from '@reduxjs/toolkit';

import {FilterValueToDffSegmentMapping} from 'components/report-configuration/report-configuration.constants';
import {EFilterValueType} from 'features/predicate-expression-form-list';
import {TAppState} from 'store/config/types';

import {REPORT_CONFIGURATION_SLICE} from '../report-configuration-constants';

const selectReportConfigurationSliceState = (state: TAppState) => state[REPORT_CONFIGURATION_SLICE];

export const selectTableReportDdLookups = (state: TAppState) => selectReportConfigurationSliceState(
    state,
).ddLookups;

export const selectTableReportConfigurationFilterConditions = createSelector(
    selectTableReportDdLookups, lookups => lookups.filters,
);

export const selectTableReportTableColumnsDdLookup = createSelector(
    selectTableReportDdLookups,
    ddLookups => ddLookups.tableColumns,
);

export const selectReportTableColumnsByTemplateCode = createSelector(
    [
        selectTableReportDdLookups,
        (_, templateCode: string) => templateCode,
    ], (ddLookups, templateCode) => ddLookups.tableColumns[templateCode],
);

interface ISelectReportTableColumnsByTemplateCodeFilteredByTypeArg {
    fieldType: EFilterValueType;
}

export const selectTableReportConfigurationFiltersByFieldType = createSelector(
    [
        selectTableReportDdLookups,
        (_, arg: ISelectReportTableColumnsByTemplateCodeFilteredByTypeArg) => arg,
    ], (ddLookups, {fieldType}) => {
        const {filters: filterConditions} = ddLookups ?? {};

        const filterConditionsFiltered = filterConditions?.filter(filterConditon => {
            const dffSegmentValue = FilterValueToDffSegmentMapping[fieldType];
            if (filterConditon?.dffSegmentValues?.[dffSegmentValue]?.segmentValue !== 'Y') return false;
            return true;
        });

        return filterConditionsFiltered;
    },
);
